import Vue from "vue";
import Loading from "./Loading.vue";
import { getStyle, setStyle, afterLeave } from "./utils";

const Mask = Vue.extend(Loading);

const loadingDirective = {};
loadingDirective.install = Vue => {
  if (Vue.prototype.$isServer) return;

  const toggleLoading = (el, binding) => {
    if (binding.value) {
      Vue.nextTick(() => {
        el.originalPosition = getStyle(el, "position");
        insertDom(el, el, binding);
      });
    } else {
      afterLeave(
        el.instance,
        _ => {
          if (!el.instance.hiding) return;
          el.domVisible = false;
          el.instance.hiding = false;
        },
        300,
        true
      );
      el.instance.visible = false;
      el.instance.hiding = true;
    }
  };

  const insertDom = (parent, el, binding) => {
    if (
      !el.domVisible &&
      getStyle(el, "display") !== "none" &&
      getStyle(el, "visibility") !== "hidden"
    ) {
      Object.keys(el.maskStyle).forEach(property => {
        setStyle(el.mask, property, el.maskStyle[property]);
      });

      if (
        el.originalPosition !== "absolute" &&
        el.originalPosition !== "fixed"
      ) {
        parent.style.position = "relative";
      }

      el.domVisible = true;

      parent.appendChild(el.mask);

      Vue.nextTick(() => {
        if (el.instance.hiding) {
          el.instance.$emit("after-leave");
        } else {
          el.instance.visible = true;
        }
      });
      el.domInserted = true;
    } else if (el.domVisible && el.instance.hiding === true) {
      el.instance.visible = true;
      el.instance.hiding = false;
    }
  };

  Vue.directive("loading", {
    bind: function(el, binding, vnode) {
      // let loading stuff be added as custom attributes
      const backgroundExr = el.getAttribute("loading-background");
      const customClassExr = el.getAttribute("loading-custom-class");
      const vm = vnode.context;

      // add loading mask
      const mask = new Mask({
        el: document.createElement("div"),
        data: {
          background: (vm && vm[backgroundExr]) || backgroundExr,
          customClass: (vm && vm[customClassExr]) || customClassExr
        }
      });

      el.instance = mask;
      el.mask = mask.$el;
      el.maskStyle = {};

      // if value is true, trigger loading
      binding.value && toggleLoading(el, binding);
    },
    update: function(el, binding) {
      if (binding.oldValue !== binding.value) {
        toggleLoading(el, binding);
      }
    },
    unbind: function(el, binding) {
      if (el.domInserted) {
        el.mask &&
          el.mask.parentNode &&
          el.mask.parentNode.removeChild(el.mask);
        toggleLoading(el, { value: false, modifiers: binding.modifiers });
      }
      el.instance && el.instance.$destroy();
    }
  });
};
export default loadingDirective;
